export default __webpack_public_path__ + "static/etharmy-2af5e8e84f58f90b69204cddb996d278.jpg";